import {Flux} from './flux';
import { Produit } from './produit';
import { isDefined } from '@angular/compiler/src/util';
import { Facture } from './facture';
import { Bordereau } from './bordereau';

export class FluxStock extends Flux {

    quantite: number;
    prix_unitaire: number;
    produit: Produit;
    // nature_stock: string;
    inventory: boolean;
    bordereau: Bordereau;

    constructor() {
        super(); // on appelle le constructeur du parent;
        this.quantite = 0;
        this.prix_unitaire = 0;
        this.inventory = false;
    }

    get quantiteFinale(): number {
        return this.quantite;
    }


    get inventaire(): string {

        status = '';

        if (this.inventory === true ) {
            status = '<span class="green"> <i class="fa fa-check" aria-hidden="true"></i> </span>';
        } else {
            status =  '<span class="red">  <i class="fa fa-times" aria-hidden="true"></i> </span>';
        }

        return status;

    }

    get nomPartenaire(): string {

        if (this.facture !== null && this.facture !== undefined) {
            if (this.facture.partenaire !== null)
            return this.facture.partenaire.nom;
            else
            return '';
        } else
        return '';

    }

    get prixTotal(): number {
        if (this.quantite === null || this.quantite === undefined || this.prix_unitaire === null || this.prix_unitaire === undefined )
        return 0;
        else
        return this.prix_unitaire * this.quantite;
    }

    /* get prixUnitaireRetour(): number {
        if (this.remise === null || this.remise === undefined )
        return this.prix_unitaire + this.montantTVA;
        else
        return this.prix_unitaire + this.montantTVA - (this.remise / this.quantite);
    } */

   /*  get prixTotalRetour(): number {
        if (this.remise === null || this.remise === undefined )
        return this.prixHTRetour + this.montantTVARetour;
        else
        return this.prixHTRetour + this.montantTVARetour - (this.remise * this.retour) / this.quantite;
    } */

    get prixHT(): number {
        if (this.quantite === null || this.prix_unitaire === null )
        return 0;
        else
        return this.quantite * this.prix_unitaire;
    }


    get nomProduit(): string {
        if (isDefined(this.produit))
        return this.produit.designation;
        else
        return '';
    }

    get formatDateflux(): string {

        return  this.formatDate(this.date_flux);

    }


}
